import { OrderChannel } from 'constant/OrderChannels'
import { DiscountContract } from 'models'
import {
    isActiveDiscount,
    notInExcludeAutoDiscountIds,
    doesDiscountContainFulfillmentType,
    isTimeEventDiscountAvailable,
    doesDiscountContainOrderChannel,
} from './discountFilter'

const generalDiscountFilter = (
    discount: DiscountContract,
    checkingFulfillmentType: number,
    excludeAutoDiscountIds: string[] = [],
    orderChannel: OrderChannel,
): boolean => {
    return (
        isActiveDiscount(discount) &&
        notInExcludeAutoDiscountIds(discount, excludeAutoDiscountIds) &&
        doesDiscountContainFulfillmentType(discount, checkingFulfillmentType) &&
        doesDiscountContainOrderChannel(discount, orderChannel) &&
        isTimeEventDiscountAvailable(discount)
    )
}

export default generalDiscountFilter
